import client from '../client'

const requestDealerAccessKey = `${process.env.NEXT_PUBLIC_ACCOUNT_DOMAIN}/api/Accounts/SendDealerAccessRequest`

export async function requestDealerAccess({
  firstName,
  lastName,
  email,
  dealershipAddress,
  phoneNumber,
  dealershipState,
  dealershipCity,
  dealershipName,
  dealershipZipCode,
}) {
  return client(requestDealerAccessKey, {
    headers: { 'Content-Type': 'application/json' },
    method: 'POST',
    body: JSON.stringify({
      firstName,
      lastName,
      email,
      dealershipAddress,
      phoneNumber,
      dealershipState,
      dealershipCity,
      dealershipName,
      dealershipZipCode,
    }),
  })
}
